import { smartAxios } from "../axios/Axios";
import { dealershipEndpoints } from "./dealershpEndpoints";

 

export const getVehicleMakes = () => {
  return smartAxios.get(dealershipEndpoints.getVehicleMakes);
};
export const getVehicles = () => {
  return smartAxios.get(dealershipEndpoints.getVehicles);
};

export const getVehicleModels = (vehicle_make: number) => {
  return smartAxios.get(
    `${dealershipEndpoints.getVehicleModels}?make=${vehicle_make}`,
  );
};

export const convertFormData = (
  data: any,
  isEdit: boolean = false,
): FormData => {
  const formData = new FormData();

  if (data.type) formData.append("type", data.type);
  if (data.number_of_owners !== undefined && data.number_of_owners !== null) {
    formData.append("number_of_owners", data.number_of_owners.toString());
  }
  if (
    data.number_of_accidents !== undefined &&
    data.number_of_accidents !== null
  ) {
    formData.append("number_of_accidents", data.number_of_accidents.toString());
  }
  if (data.body_type) formData.append("body_type", data.body_type);
  if (data.make !== undefined && data.make !== null) {
    formData.append("make", data.make.toString());
  }
  if (data.model !== undefined && data.model !== null) {
    formData.append("model", data.model.toString());
  }
  if (data.year !== undefined && data.year !== null) {
    formData.append("year", data.year.toString());
  }
  if (data.mileage !== undefined && data.mileage !== null) {
    formData.append("mileage", data.mileage.toString());
  }
  if (data.article_code) formData.append("article_code", data.article_code);
  if (data.serial_number) formData.append("serial_number", data.serial_number);
  if (data.description) formData.append("description", data.description);
  if (data.notes) formData.append("notes", data.notes);
  if (data.price !== undefined && data.price !== null) {
    formData.append("price", data.price.toString());
  }
  if (data.leasing_price !== undefined && data.leasing_price !== null) {
    formData.append("leasing_price", data.leasing_price.toString());
  }
  if (data.is_demo !== undefined) {
    formData.append("is_demo", data.is_demo.toString());
  }
  if (data.engine) formData.append("engine", data.engine);
  if (data.engine_origin) formData.append("engine_origin", data.engine_origin);
  if (data.motor_volume) formData.append("motor_volume", data.motor_volume);
  if (data.motor_cylinders !== undefined && data.motor_cylinders !== null) {
    formData.append("motor_cylinders", data.motor_cylinders.toString());
  }
  if (data.horse_power !== undefined && data.horse_power !== null) {
    formData.append("horse_power", data.horse_power.toString());
  }
  if (data.torque) formData.append("torque", data.torque);
  if (data.transmission_type) {
    formData.append("transmission_type", data.transmission_type);
  }
  if (data.transmission_speed) {
    formData.append("transmission_speed", data.transmission_speed);
  }
  if (data.warranty) formData.append("warranty", data.warranty);
  if (data.exterior_color)
    formData.append("exterior_color", data.exterior_color);
  if (data.interior_color)
    formData.append("interior_color", data.interior_color);
  if (data.interior_type) formData.append("interior_type", data.interior_type);

  if (data.viewing_duration !== undefined && data.viewing_duration !== null) {
    formData.append("viewing_duration", data.viewing_duration.toString());
  }
  if (data.viewing_duration_time_unit) {
    const unit = !data.viewing_duration_time_unit.endsWith("s")
      ? data.viewing_duration_time_unit + "s"
      : data.viewing_duration_time_unit;
    formData.append("viewing_duration_time_unit", unit);
  }
  if (data.buffer_time !== undefined && data.buffer_time !== null) {
    formData.append("buffer_time", data.buffer_time.toString());
  }
  if (data.buffer_time_time_unit) {
    const unit = !data.buffer_time_time_unit.endsWith("s")
      ? data.buffer_time_time_unit + "s"
      : data.buffer_time_time_unit;
    formData.append("buffer_time_time_unit", unit);
  }

  if (data.technical_document) {
    if (
      typeof File !== "undefined" &&
      (data.technical_document instanceof File ||
        data.technical_document instanceof Blob)
    ) {
      formData.append("technical_document", data.technical_document);
    } else if (
      typeof File !== "undefined" &&
      data.technical_document.file &&
      (data.technical_document.file instanceof File ||
        data.technical_document.file instanceof Blob)
    ) {
      formData.append("technical_document", data.technical_document.file);
    } else {
      const docUri = data.technical_document.uri;
      if (docUri && typeof docUri === "string" && !docUri.startsWith("http")) {
        formData.append("technical_document", {
          uri: docUri,
          name: data.technical_document.name || "document.pdf",
          type:
            data.technical_document.mimeType ||
            data.technical_document.type ||
            "application/pdf",
        } as any);
      }
    }
  }

  if (data.technical_document_remove) {
    formData.append("technical_document_remove", "true");
  }

  const appendImageField = (fieldName: string, file: any, fallbackName: string) => {
    const fileObj =
      (typeof File !== "undefined" && (file instanceof File || file instanceof Blob) && file) ||
      (file?.file && typeof File !== "undefined" && (file.file instanceof File || file.file instanceof Blob) && file.file);

    if (fileObj) {
      formData.append(fieldName, fileObj);
    } else if (file?.uri) {
      formData.append(fieldName, {
        uri: file.uri,
        name: file.name || fallbackName,
        type: file.mimeType || file.type || "image/jpeg",
      } as any);
    }
  };

  if (isEdit) {
    // Exterior images edit
    if (data.exterior_images_remove && data.exterior_images_remove.length > 0) {
      data.exterior_images_remove.forEach((item: any) => {
        formData.append(`exterior_images_remove[]`, item.toString());
      });
    }

    if (
      data.exterior_images_update_labels &&
      data.exterior_images_update_labels.length > 0
    ) {
      data.exterior_images_update_labels.forEach(
        (item: { id: number; label: string }, index: number) => {
          formData.append(
            `exterior_images_update_labels[${index}]id`,
            item.id.toString(),
          );
          formData.append(
            `exterior_images_update_labels[${index}]label`,
            item.label,
          );
        },
      );
    }

    if (data.exterior_images && data.exterior_images.length > 0) {
      let extAddIndex = 0;
      data.exterior_images.forEach((file: any) => {
        if (typeof file.id !== "number") {
          appendImageField(
            `exterior_images_add[${extAddIndex}]image`,
            file,
            `photo_${extAddIndex}.jpg`,
          );
          if (file.label) {
            formData.append(`exterior_images_add[${extAddIndex}]label`, file.label);
          }
          extAddIndex++;
        }
      });
    }

    // Interior images edit
    if (data.interior_images_remove && data.interior_images_remove.length > 0) {
      data.interior_images_remove.forEach((item: any) => {
        formData.append(`interior_images_remove[]`, item.toString());
      });
    }

    if (
      data.interior_images_update_labels &&
      data.interior_images_update_labels.length > 0
    ) {
      data.interior_images_update_labels.forEach(
        (item: { id: number; label: string }, index: number) => {
          formData.append(
            `interior_images_update_labels[${index}]id`,
            item.id.toString(),
          );
          formData.append(
            `interior_images_update_labels[${index}]label`,
            item.label,
          );
        },
      );
    }

    if (data.interior_images && data.interior_images.length > 0) {
      let intAddIndex = 0;
      data.interior_images.forEach((file: any) => {
        if (typeof file.id !== "number") {
          appendImageField(
            `interior_images_add[${intAddIndex}]image`,
            file,
            `photo_${intAddIndex}.jpg`,
          );
          if (file.label) {
            formData.append(`interior_images_add[${intAddIndex}]label`, file.label);
          }
          intAddIndex++;
        }
      });
    }

    // Legacy fallback
    if (data.images_remove && data.images_remove.length > 0) {
      data.images_remove.forEach((item: any) => {
        formData.append(`images_remove`, item.toString());
      });
    }

    if (data.images_update_labels && data.images_update_labels.length > 0) {
      data.images_update_labels.forEach(
        (item: { id: number; label: string }, index: number) => {
          formData.append(
            `images_update_labels[${index}]id`,
            item.id.toString(),
          );
          formData.append(`images_update_labels[${index}]label`, item.label);
        },
      );
    }

    if (data.images && data.images.length > 0) {
      let imgAddIndex = 0;
      data.images.forEach((file: any) => {
        if (typeof file.id !== "number") {
          appendImageField(
            `images_add[${imgAddIndex}]image`,
            file,
            `photo_${imgAddIndex}.jpg`,
          );
          if (file.label) {
            formData.append(`images_add[${imgAddIndex}]label`, file.label);
          }
          imgAddIndex++;
        }
      });
    }
  } else {
    // Exterior images create
    if (data.exterior_images && data.exterior_images.length > 0) {
      data.exterior_images.forEach((file: any, index: number) => {
        appendImageField(
          `exterior_images[${index}]image`,
          file,
          `photo_${index}.jpg`,
        );
        if (file.label) {
          formData.append(`exterior_images[${index}]label`, file.label);
        }
      });
    }

    // Interior images create
    if (data.interior_images && data.interior_images.length > 0) {
      data.interior_images.forEach((file: any, index: number) => {
        appendImageField(
          `interior_images[${index}]image`,
          file,
          `photo_${index}.jpg`,
        );
        if (file.label) {
          formData.append(`interior_images[${index}]label`, file.label);
        }
      });
    }

    // Legacy fallback
    if (data.images && data.images.length > 0) {
      data.images.forEach((file: any, index: number) => {
        appendImageField(
          `images[${index}]image`,
          file,
          `photo_${index}.jpg`,
        );
        if (file.label) {
          formData.append(`images[${index}]label`, file.label);
        }
      });
    }
  }

  // Boolean features
  const standardKeys = new Set([
    "type",
    "number_of_owners",
    "number_of_accidents",
    "body_type",
    "make",
    "model",
    "year",
    "mileage",
    "article_code",
    "serial_number",
    "description",
    "notes",
    "price",
    "leasing_price",
    "is_demo",
    "engine",
    "engine_origin",
    "motor_volume",
    "motor_cylinders",
    "horse_power",
    "torque",
    "transmission_type",
    "transmission_speed",
    "warranty",
    "exterior_color",
    "interior_color",
    "interior_type",
    "viewing_duration",
    "viewing_duration_time_unit",
    "buffer_time",
    "buffer_time_time_unit",
    "images",
    "images_remove",
    "images_add",
    "images_update_labels",
    "exterior_images",
    "exterior_images_remove",
    "exterior_images_remove[]",
    "exterior_images_add",
    "exterior_images_update_labels",
    "interior_images",
    "interior_images_remove",
    "interior_images_remove[]",
    "interior_images_add",
    "interior_images_update_labels",
    "technical_document",
    "technical_document_remove",
  ]);

  Object.keys(data).forEach((key) => {
    if (
      !standardKeys.has(key) &&
      data[key] !== undefined &&
      data[key] !== null
    ) {
      formData.append(key, data[key].toString());
    }
  });

  return formData;
};

export const postVehicle = (data: any) => {
  const bodyData =
    data instanceof FormData ? data : convertFormData(data, false);

  return smartAxios.post(dealershipEndpoints.postVehicle, bodyData);
};

export const deleteVehicle = (id: number | string) => {
  return smartAxios.delete(`${dealershipEndpoints.deleteVehicle}${id}/`);
};
export const getVehicleDetails = (id: number | string) => {
  return smartAxios.get(`${dealershipEndpoints.getVehicleDetails}${id}/`);
};

export const putVehicle = (id: number | string, data: any) => {
  const bodyData =
    data instanceof FormData ? data : convertFormData(data, true);
  return smartAxios.put(
    `${dealershipEndpoints.putVehicleDetails}${id}/`,
    bodyData,
  );
};
